import auth from "../../middlewares/auth";
export const settingsGradeRoute = [
  {
    path: '/settings/grade',
    component: () => import(/* webpackChunkName: "settings" */ '../../views/settings/grade/GradeList'),
    name: 'settings_grade',
    meta: {
      middleware: [
        auth
      ]
    }
  },
  {
    path: '/settings/grade/add',
    component: () => import(/* webpackChunkName: "settings" */ '../../views/settings/grade/GradeForm'),
    name: 'settings_grade_add',
    meta: {
      middleware: [
        auth
      ]
    }
  },
  {
    path: '/settings/grade/edit/:id',
    component: () => import(/* webpackChunkName: "settings" */ '../../views/settings/grade/GradeForm'),
    name: 'settings_grade_edit',
    meta: {
      middleware: [
        auth
      ]
    }
  }
];